export default "__VITE_ASSET__BsbXdKop__"